import { createEntityFilterConfig } from '../../factories/create-entity-filter-config';
import { STATIC_FILTER_ENTITY_TYPES } from '@shared/features/views/components/entities-filters/config';
import labelApi from '@src/shared/components/reusables/labels/services/label-api';
import { LabelFilterOptionItem } from './filter-option-item';
import { FILTER_COLOR } from '../filter-colors';

export const labelFilterConfig = createEntityFilterConfig({
  facetName: 'labels',
  fetchInfiniteData: labelApi.useFetchInfinite,
  entityType: STATIC_FILTER_ENTITY_TYPES.label,
  getValue: (item) => String(item.id),
  renderItem: LabelFilterOptionItem,
  color: FILTER_COLOR.pink,
});
